import {PortableText} from '@/modules/foundation/sanity/portable-text';
import {PORTABLE_TEXT_FRAGMENT} from '@/modules/foundation/sanity/portable-text/query';

import {DOCUMENT_TYPE_BANK_AREA} from '../../field-of-area/bank/area/sanity/constants';
import {DOCUMENT_TYPE_BANK_FRONTPAGE} from '../../field-of-area/bank/frontpage/sanity/constants';
import {DOCUMENT_TYPE_COLLECTION_AREA} from '../../field-of-area/collection/area/sanity/constants';
import {DOCUMENT_TYPE_COLLECTION_FRONTPAGE} from '../../field-of-area/collection/frontpage/sanity/constants';
import {DOCUMENT_TYPE_INSURANCE_AREA} from '../../field-of-area/insurance/area/sanity/constants';
import {DOCUMENT_TYPE_INSURANCE_FRONTPAGE} from '../../field-of-area/insurance/frontpage/sanity/constants';
import type {AreaFilters} from '../../shared/components/filters/category-filters';
import type {FaqListAllFragment} from '../content-blocks/sanity/faq-list-all/query';
import type {FAQ} from '../types';

export const FAQ_IN_CARD_FRAGMENT = `//groq
	...,
	answer[] {
		${PORTABLE_TEXT_FRAGMENT}
	},
	fieldOfAreas[]-> {
		"slug": slug.current,
		title,
		_id
	},
	areas[]-> {
		"slug": slug.current,
		title,
		_type == "${DOCUMENT_TYPE_INSURANCE_AREA}" => {
			"fieldOfAreaParentSlug": *[_type == "${DOCUMENT_TYPE_INSURANCE_FRONTPAGE}"][0].slug.current
		},
		_type == "${DOCUMENT_TYPE_BANK_AREA}" => {
			"fieldOfAreaParentSlug": *[_type == "${DOCUMENT_TYPE_BANK_FRONTPAGE}"][0].slug.current
		},
		_type == "${DOCUMENT_TYPE_COLLECTION_AREA}" => {
			"fieldOfAreaParentSlug": *[_type == "${DOCUMENT_TYPE_COLLECTION_FRONTPAGE}"][0].slug.current
		}
	}
`;

export type FaqAreaFilters = AreaFilters & {
	fieldOfAreaParentSlug?: string;
};

export type FaqInCardFragment = FaqListAllFragment['faqs'][number];

export function faqInCardFragmentToFaq(faq: FaqInCardFragment): FAQ {
	return {
		question: faq.question ?? '',
		answer: faq.answer && faq.answer.length > 0 ? <PortableText value={faq.answer} /> : null,
		areas: faq.areas?.map((area) => area.slug ?? '') ?? [],
		fieldOfAreas: faq.fieldOfAreas?.map((area) => area._id ?? '') ?? ['generelt'],
	};
}
